///////////////////////// Like \\\\\\\\\\\\\\\\\\\\\\\\\
export const likePost = postId => ({
  type: "LIKE_POST_REQUEST",
  postId,
});

export const likePostOptimistic = postId => ({
  type: "LIKE_POST_OPTIMISTIC",
  postId,
});

export const likePostFailed = postId => ({
  type: "LIKE_POST_FAILED",
  postId,
});

/////////////////////// Unlike \\\\\\\\\\\\\\\\\\\\\\\\\
export const unlikePost = postId => ({
  type: "UNLIKE_POST_REQUEST",
  postId,
});

export const unlikePostOptimistic = postId => ({
  type: "UNLIKE_POST_OPTIMISTIC",
  postId,
});

export const unlikePostFailed = postId => ({
  type: "UNLIKE_POST_FAILED",
  postId,
});

export const loadCurrentPostBySlugRequest = slug => {
  return {
    type: "LOAD_CURRENT_POST_BY_SLUG_REQUEST",
    slug,
  };
};

export const loadCurrentPostByIdRequest = id => {
  return {
    type: "LOAD_CURRENT_POST_BY_ID_REQUEST",
    id,
  };
};

export const loadCurrentPostSuccess = post => {
  return {
    type: "LOAD_CURRENT_POST_SUCCESS",
    post,
    meta: {
      mixpanel: {
        event: "post.view",
        props: {
          id: post._id,
        },
      },
    },
  };
};

export const loadCurrentPostFailed = error => {
  return {
    type: "LOAD_CURRENT_POST_FAILED",
    error,
  };
};

export const clearCurrentPost = () => ({
  type: "CLEAR_CURRENT_POST",
});

///////////////////////// DELETE \\\\\\\\\\\\\\\\\\\\\\\\\
export const deletePost = (postId, redirectionRoute) => ({
  type: "DELETE_POST_REQUEST",
  postId,
  redirectionRoute,
  asAdmin: false,
  meta: {
    mixpanel: {
      event: "post.delete",
      props: {
        id: postId,
      },
    },
  },
});

export const deletePostAsAdmin = (postId, redirectionRoute) => ({
  type: "DELETE_POST_REQUEST",
  postId,
  redirectionRoute,
  asAdmin: true,
});

export const deletePostOptimistic = postId => ({
  type: "DELETE_POST_OPTIMISTIC",
  postId,
});

export const deletePostFailed = postId => ({
  type: "DELETE_POST_FAILED",
  postId,
});

///////////////////////// HIDE \\\\\\\\\\\\\\\\\\\\\\\\\
export const hidePostAsAdmin = (postId, redirectionRoute) => ({
  type: "HIDE_POST_REQUEST",
  postId,
  redirectionRoute,
});

export const hidePostOptimistic = postId => {
  return {
    type: "HIDE_POST_OPTIMISTIC",
    postId,
  };
};

export const hidePostFailed = postId => {
  return {
    type: "HIDE_POST_FAILED",
    postId,
  };
};

export const unhidePostAsAdmin = (postId, redirectionRoute) => ({
  type: "UNHIDE_POST_REQUEST",
  postId,
  redirectionRoute,
});

export const unhidePostOptimistic = postId => {
  return {
    type: "UNHIDE_POST_OPTIMISTIC",
    postId,
  };
};

export const unhidePostFailed = postId => {
  return {
    type: "UNHIDE_POST_FAILED",
    postId,
  };
};

//////////////////// Move to the top (float post) \\\\\\\\\\\\\\\\\\\\
export const floatPostAsAdmin = postId => ({
  type: "FLOAT_POST_REQUEST",
  postId,
});

export const floatPostSuccess = postId => ({
  type: "FLOAT_POST_SUCCESS",
  postId,
});

export const floatPostFailed = postId => ({
  type: "FLOAT_POST_FAILED",
  postId,
});

////////////////// New publish \\\\\\\\\\\\\\\\\\\\\\\\
export const setIsJustPublished = () => ({ type: "SET_JUST_PUBLISHED" });

export const clearIsJustPulished = () => ({ type: "CLEAR_JUST_PUBLISHED" });

////////////////// Comments \\\\\\\\\\\\\\\\\\\\\\\\
export const loadPostComments = (postId, options = {}) => {
  const { limit = 10, pagingToken = null } = options;
  return {
    type: "LOAD_POST_COMMENTS_REQUEST",
    postId,
    limit,
    pagingToken,
  };
};

export const loadPostCommentsSuccess = ({ comments, pagingToken, limit }) => {
  return {
    type: "LOAD_POST_COMMENTS_SUCCESS",
    comments,
    pagingToken,
    limit,
  };
};

export const setCurrentPostCommentsFetchingStatus = fetchingStatus => {
  return {
    type: "SET_CURRENT_POST_COMMENTS_FETCHING_STATUS",
    fetchingStatus,
  };
};

/////////////////// Recommended posts \\\\\\\\\\\\\\\\\\\\\\\\\
export const loadSimilarPosts = (postId, options = {}) => {
  const { pagingToken = null } = options;
  return {
    type: "LOAD_SIMILAR_POSTS_REQUEST",
    postId,
    pagingToken,
  };
};

export const loadSimilarPostsSuccess = ({ similarPosts, pagingToken }) => {
  return {
    type: "LOAD_SIMILAR_POSTS_SUCCESS",
    similarPosts,
    pagingToken,
  };
};



// WEBPACK FOOTER //
// ./src/actions/postActions.js